import { Action } from 'redux';
import { UserAdminActions } from './actionTypes';
import { UserAdminState } from './models';

const initialState: UserAdminState = {
    anagrafiche: [],
    ubicazioni: [],
}

export default (
    state: UserAdminState = initialState, 
    incomingAction: Action
): UserAdminState => {

    const action = incomingAction as UserAdminActions;
    switch (action.type) {
        case 'userAdmin/LOAD_ANAGRAFICHE_CUSTOM':
            return { 
                ...state, 
                anagrafiche: action.value
            };
        case 'userAdmin/LOAD_UBICAZIONI':
            return { 
                ...state, 
                ubicazioni: action.value
            };

        default: return state;
    }
};